import { Injectable, signal } from '@angular/core';

export interface MiniUserProfile {
  userId: number;
  telegramId: number;
  firstName: string;
  lastName: string;
  username: string;
  languageCode: string;
  sponsorId: number | null;
  memberStatus: string | null;
  sponsor: {
    userId: number;
    firstName: string;
    lastName: string;
    username: string;
  } | null;
}

export const MEMBER_STATUS_ROLES = [
  "Unknown",
  "InteressentNEW",
  "InteressentNO",
  "ClubMemberBasic",
  "ClubMemberProfile",
  "SUPPORT",
];

@Injectable({ providedIn: 'root' })
export class AppStateService {
  readonly profile = signal<MiniUserProfile | null>(null);
  readonly authenticated = signal(false);
}
